import React from "react";
import { arrayOf, shape, string } from "prop-types";
import SectionHeading from "../../molecules/SectionHeading";
import CardsGrid from "../../molecules/CardsGrid";
import SpecialCard from "../../molecules/SpecialCard";
import SectionLink from "../../atoms/SectionLink";

import "./conferences-section.m.css";

const CONFERENCES_LINK_TEXT = "Upcoming conferences and archive";

const ConferencesSection = ({
  tags,
  highlightText,
  basicCards,
  specialCards,
  linkHref,
  highlightHeading,
  ...props
}) => {

const strongText = highlightHeading?.match(/<strong>(.*?)<\/strong>/)[1].trim();
const normalText = highlightHeading?.replace(/.*<\/strong>/, '')?.replace(/<\/?p>/g, '')?.trim();

  return (
    <section styleName="conferences-section" {...props}>
      <div styleName="container">
        <SectionHeading
          tags={tags}
          highlightHeading={highlightHeading}
          highlightText={strongText}
          normalText={normalText}
        />

        <div styleName="highlight-text">
          <p>{highlightText}</p>
        </div>

        <CardsGrid cards={basicCards} />

        <div styleName="special-cards-grid">
          {specialCards?.map((card, index) => (
            <SpecialCard
              key={index}
              title={card?.title}
              sections={card?.sections}
            />
          ))}
        </div>

        <SectionLink href={linkHref}>
          {CONFERENCES_LINK_TEXT}
        </SectionLink>
      </div>
    </section>
  );
};

ConferencesSection.propTypes = {
  tags: arrayOf(string),
  highlightText: string,
  basicCards: arrayOf(shape({
    title: string,
    content: string
  })),
  specialCards: arrayOf(shape({
    title: string,
    sections: arrayOf(shape({
      title: string,
      content: string
    }))
  })),
  linkHref: string
};

export default ConferencesSection;